import { render, staticRenderFns } from "./meetingItem.vue?vue&type=template&id=13c47d5b&scoped=true&"
import script from "./meetingItem.vue?vue&type=script&lang=js&"
export * from "./meetingItem.vue?vue&type=script&lang=js&"
import style0 from "./meetingItem.vue?vue&type=style&index=0&id=13c47d5b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c47d5b",
  null
  
)

export default component.exports